// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"be4d1acd","513":"3ff9fb2f","703":"8ad71da5"}[chunkId] + ".chunk.js";
};